import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { TableCompHead } from '../../../../components/ui';
import { useQuery } from '../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
};

const theadData = [
  [
    { text: 'Item Name', style: { minWidth: '300px' } },
    { text: 'Operation', style: { minWidth: '250px' } },
    { text: 'Qty', style: { minWidth: '80px' } },
    { text: 'Rate', style: { minWidth: '80px' } },
    { text: 'Amount', style: { minWidth: '80px' } },
    { text: 'NET WT', style: { minWidth: '80px' } },
    { text: 'TOTAL WT', style: { minWidth: '80px' } },
    { text: 'AMT', style: { minWidth: '80px' } },
    { text: 'Remarks', style: { minWidth: '200px' } },
  ],
];

const THead = ({ moduleData, isView }: IProps) => {
  const annual_date = useQuery('annual_date');
  const employee_name = useQuery('employee_name');

  return (
    <thead>
      <TableCompHead
        colSpan={9}
        rowSpan={1}
        labels={[]}
        values={[]}
        heading={`SALARY FOR THE MONTH OF ${annual_date}`}
      />
      <tr>
        <th>{`${employee_name?.toUpperCase()}  Salary`}</th>
      </tr>
      <TableHeaderHtmlCustom tableHeaderObj={theadData} customStyle={style1} />
    </thead>
  );
};

export default THead;
